import mapData from "../data/presenceMap.json";

const STATE_META = {
    Maharashtra: { label: ["MAHARASHTRA"], fontSize: 24, testId: "presence-state-maharashtra" },
    Karnataka: { label: ["KARNATAKA"], fontSize: 21, testId: "presence-state-karnataka" },
    Telangana: { label: ["TELANGANA"], fontSize: 13, testId: "presence-state-telangana" },
    "Andhra Pradesh": { label: ["ANDHRA", "PRADESH"], fontSize: 15, lineHeight: 21, testId: "presence-state-andhra-pradesh" },
};

export const PresenceMap = () => {
    const context = mapData.states.filter((s) => !s.highlight);
    const highlighted = mapData.states.filter((s) => s.highlight);

    return (
        <svg
            viewBox={mapData.viewBox}
            className="block h-auto w-full"
            role="img"
            aria-label="Map of western and southern India highlighting Maharashtra, Telangana, Karnataka and Andhra Pradesh as areas of VEC project presence"
        >
            <defs>
                <pattern id="vec-state-fill" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                    <rect width="8" height="8" fill="#08783E" fillOpacity="0.6" />
                    <line x1="0" y1="0" x2="0" y2="8" stroke="#08783E" strokeOpacity="0.22" strokeWidth="0.9" />
                </pattern>
            </defs>
            {context.map((s) => (
                <path
                    key={s.name}
                    d={s.path}
                    fill="#F4F7F5"
                    stroke="#E2EAE4"
                    strokeWidth="1"
                    strokeLinejoin="round"
                />
            ))}
            {highlighted.map((s) => (
                <g key={s.name} className="presence-state">
                    <path
                        data-testid={STATE_META[s.name].testId}
                        d={s.path}
                        fill="url(#vec-state-fill)"
                        stroke="#0A6B38"
                        strokeWidth="1.2"
                        strokeLinejoin="round"
                    />
                    <path d={s.path} className="presence-state-hover" fill="#08783E" pointerEvents="none" />
                </g>
            ))}
            {highlighted.map((s) => {
                const meta = STATE_META[s.name];
                if (!s.label) return null;
                return (
                    <text
                        key={`${s.name}-label`}
                        x={s.label[0]}
                        y={s.label[1]}
                        textAnchor="middle"
                        className="presence-state-label"
                        paintOrder="stroke"
                        stroke="rgba(255,255,255,0.8)"
                        strokeWidth="3.5"
                        style={{
                            fontFamily: "'JetBrains Mono', monospace",
                            fontSize: meta.fontSize,
                            letterSpacing: "0.18em",
                        }}
                    >
                        {meta.label.map((line, li) => (
                            <tspan
                                key={line}
                                x={s.label[0]}
                                dy={li === 0 ? 0 : meta.lineHeight || meta.fontSize + 4}
                            >
                                {line}
                            </tspan>
                        ))}
                    </text>
                );
            })}
        </svg>
    );
};
